





import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdiDocs from "@/components/JdiDocs.vue"

@Component({
    components: {JdiDocs, JdiPreview, JdiContent}
})
export default class FormsValidation extends Vue {
}
